<template>
  <scroll-view class="operation-index" :scroll="true">
    <div class="operation-flex-text">
      <div class="operation-flex-text-flex">
        <div style="flex: 1;">一级目录</div>
        <div @click="onCancel(true)" class="operation-flex-text-div">
          <span>
            操作
            <span class="iconfont icon-046"></span>
          </span>
        </div>
        <div :class="['operation-flex-text-button', sortName]" @click="sortTap()">完成</div>
      </div>
    </div>

    <div class="operation-flex-tip">tip：平台的图库移动位置不生效</div>

    <draggable class="list-group" tag="ul" v-model="list" v-bind="dragOptions" style="margin-bottom: 3rem;">
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div class="operation-modules" v-for="(element, index) in list" :key="index">
          <div class="dragBody-item-flex">
            <img src="../../../../assets/img/file.png" @click="onCancelDiv(true, element)" />
            <div class="dragBody-item-head-hide-ls" v-if="element.album_id == 0">平台</div>
            <div class="dragBody-item-head-hide" v-if="element.is_hide_switch == 1">隐藏</div>
            <div class="dragBody-item-head-hide-tui" v-if="element.is_recom_switch == 1">推</div>
          </div>
          <div style="flex: 1;">{{ element.name }}</div>
        </div>
        <!-- @click="onCancelDiv(true, element)" -->
      </transition-group>
    </draggable>

    <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" @cancel="onCancel(false)" @select="onSelect"></van-action-sheet>

    <van-action-sheet v-if="directory.album_id != 0" v-model="showDiv" :actions="actionsDiv" cancel-text="取消" @cancel="onCancelDiv(false)" @select="onSelect"></van-action-sheet>
    <van-action-sheet
      v-else
      v-model="showDiv"
      :actions="[{ name: '编辑目录' }, { name: '进入目录' }]"
      cancel-text="取消"
      @cancel="onCancelDiv(false)"
      @select="onSelect"
    ></van-action-sheet>
  </scroll-view>
</template>

<script>
import draggable from 'vuedraggable';
import { ActionSheet } from 'vant';
import { Adminalbumdirectoryget, Adminalbumdirectorydel, Adminalbumdirectoryexchange, Albumlevelgetinfo, Albumgetinfo } from '@/request/api.js';
const message = [];
export default {
  components: {
    draggable,
    [ActionSheet.name]: ActionSheet
  },
  data() {
    return {
      show: false,
      list: [],
      yeslist: [],
      drag: false,
      actionsDiv: [
        {
          name: '删除目录'
        },
        {
          name: '编辑目录'
        },
        {
          name: '进入目录'
        }
      ],
      actions: [
        {
          name: '增加目录'
        },
        {
          name: '排序目录'
        }
      ],
      sortName: 'operation-flex-text-button-state',
      showDiv: false,
      directory: 0
    };
  },
  async created() {
    let res = await Albumlevelgetinfo('');
    let newRes = await Albumgetinfo('');
    newRes = newRes.data;
    newRes['used_space'] = res.data.used_space;
    newRes['pic_space'] = res.data.pic_space;
    this.$api.commit('userInfo', newRes);
    this.list_load();
    typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        ghostClass: 'ghost',
        disabled: this.sortName == 'operation-flex-text-button-hover' ? false : true
      };
    }
  },
  methods: {
    async list_load() {
      let res = await Adminalbumdirectoryget({
        parent_id: 0,
        album_id: this.$store.state.userInfo.album_id,
        operate_album_id: this.$store.state.userInfo.album_id
      });
      this.list = res.data.map((name, index) => {
        return {
          name: name.name,
          order: index + 1,
          img_url: name.image_text,
          directory_id: name.directory_id,
          album_id: name.album_id,
          is_recom_switch: name.is_recom_switch,
          is_hide_switch: name.is_hide_switch,
          is_enable_switch: name.is_enable_switch
        };
      });
    },
    onSelect(item) {
      this.show = false;
      let _self = this;
      if (item.name == '增加目录') {
        this.$router.push({
          path: '/contactCatalog/progeny/increase'
        });
      }
      if (item.name == '进入目录') {
        this.joinTap(this.directory);
      }
      if (item.name == '编辑目录') {
        this.$router.push({
          path: '/contactCatalog/progeny/increaseEdit?directory_id=' + this.directory.directory_id + '&album_id=' + this.directory.album_id
        });
      }
      if (item.name == '排序目录') {
        this.yeslist = this.list;
        this.sortName = 'operation-flex-text-button-hover';
      }
      if (item.name == '删除目录') {
        let param = {
          ids: this.directory.directory_id,
          operate_album_id: this.$store.state.userInfo.album_id
        };
        this.$api.Message('提示', '是否删除改文件?').then(res => {
          if (res) {
            Adminalbumdirectorydel(param).then(data => {
              _self.list_load();
              _self.showDiv = false;
            });
          }
        });
      }
    },
    sortTap() {
      let newList = new Array();
      this.sortName = 'operation-flex-text-button-hover-alternate';

      let str = '';
      this.list.map(item => {
        str += str.length == 0 ? item.directory_id : ',' + item.directory_id;
      });

      this.yeslist.map((item, index) => {
        if (item.directory_id != this.list[index].directory_id && newList.indexOf(item.directory_id) == -1) {
          newList.push(item.directory_id, this.list[index].directory_id);
          Adminalbumdirectoryexchange({
            id1: item.directory_id,
            id2: this.list[index].directory_id,
            album_id: this.$store.state.userInfo.album_id,
            operate_album_id: this.$store.state.userInfo.album_id,
            pic_ids: str
          }).then(res => {
            console.log(res);
          });
        }
      });
    },
    onCancel(close) {
      this.show = close;
    },
    onCancelDiv(close, item) {
      if (this.sortName != 'operation-flex-text-button-hover') {
        this.directory = close ? item : this.directory;
        this.showDiv = close;
      }
    },
    joinTap(item) {
      if (this.sortName != 'operation-flex-text-button-hover') {
        this.$router.push({
          path: '/contactCatalog/progeny/operationSecondLevel?directory_id=' + item.directory_id + '&album_id=' + item.album_id
        });
      }
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    }
  }
};
</script>

<style lang="less">
.operation-index {
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;

  .operation-flex-text {
    width: 100%;
    background-color: #ffffff;
    margin-bottom: 3rem;
    box-shadow: 0px 0px 10px #d5d6d8;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: hidden;
    z-index: 1000;
  }

  .operation-flex-text-flex {
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    overflow: hidden;
    width: 90%;
    position: relative;
    padding: 5%;
    width: 100%;
  }

  .operation-flex-text-button {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background-color: #ff0000;
    position: absolute;
    top: 0;
    right: 0;
    overflow: hidden;
    width: 100%;
  }

  .operation-flex-text-button-state {
    transform: translateX(100%);
  }

  .operation-flex-text-button-hover {
    animation: operation-hover 0.5s forwards;
  }

  .operation-flex-text-button-hover-alternate {
    animation: operation-hover-alternate 0.5s forwards;
  }

  @keyframes operation-hover {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes operation-hover-alternate {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(100%);
    }
  }

  .operation-flex-text-div {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
    color: #999;
  }

  .operation-flex-text-div > div {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .operation-flex-text-img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    min-height: 20px;
    width: 100%;
  }

  .list-group > span {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .operation-modules {
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;
    // width: 90%;
    // background-color: #ffffff;
    // padding: 5% 2%;
    // margin-left: 3%;
    // box-shadow: 0px 0px 10px #d5d6d8;
    // display: flex;
    // flex-wrap: nowrap;
    // justify-content: space-between;
    // align-items: center;
  }

  .dragBody-item-flex {
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    width: 60%;
    padding-top: 60%;
    margin-bottom: 0.3rem;
  }

  .dragBody-item-flex > img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .dragBody-item-head-hide-ls {
    display: inline-block;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
    background-color: #189f92;
    color: #fff;
    width: 30px;
    left: 0;
    position: absolute;
    z-index: 10;
    top: 0;
  }

  .dragBody-item-head-hide-tui {
    display: inline-block;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
    background-color: #1e9fff;
    color: #fff;
    bottom: 0.3rem;
    left: 0;
    position: absolute;
    z-index: 10;
  }

  .dragBody-item-head-hide {
    display: inline-block;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
    background-color: #ff0000;
    color: #fff;
    bottom: 0.3rem;
    right: 0;
    position: absolute;
    z-index: 10;
  }

  .operation-flex-tip {
    width: 90%;
    padding: 0 5%;
    color: #ff0000;
    margin-bottom: 1rem;
  }
}
</style>
